import * as Sentry from '@sentry/react';

export interface UserDetails {
  role: string;
  [key: string]: unknown;
}

export function setSentryUserDetails(userDetails: UserDetails) {
  Sentry.setContext('user_details', userDetails);
}
